import { LanguageProvider } from "./contexts/LanguageContext"
import { PrivacyPolicyProvider } from "./contexts/PrivacyPolicyContext"
import { TermsOfUseProvider } from "./contexts/TermsOfUseContext"
import { BrowserRouter, Routes, Route } from "react-router-dom"
import Header from "./components/Header"
import Footer from "./components/Footer"
import HomePage from "./pages/HomePage"
import ApartmentDetails from "./components/ApartmentDetails"
import WhatsAppButton from "./components/WhatsAppButton"
import Blog from "./pages/Blog"
import BlogPost from "./pages/BlogPost"
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage"
import TermsOfUsePage from "./pages/TermsOfUsePage"
import NotFound from "./pages/NotFound"

// Import combined apartment context provider
import ApartmentContextProvider from "./contexts/aparts/ApartmentContextProvider"

// Import modular CSS files
import "./styles/globals.css"
import "./styles/Header.css"
import "./styles/Hero.css"
import "./styles/FilterBar.css"
import "./styles/ApartmentListings.css"
import "./styles/About.css"
import "./styles/Contact.css"
import "./styles/Map.css"
import "./styles/Footer.css"
import "./styles/ApartmentDetails.css"
import "./styles/animations.css" // יבוא קובץ האנימציות החדש
import "./styles/NotFound.css" // יבוא קובץ העיצוב לדף 404
// WhatsAppButton uses Tailwind CSS, no need for separate CSS file

function App() {
  return (
    <LanguageProvider>
      <ApartmentContextProvider>
        <PrivacyPolicyProvider>
          <TermsOfUseProvider>
            <BrowserRouter>
              <div className="App">
                <Header />
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/apartment/:id" element={<ApartmentDetails />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:id" element={<BlogPost />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                  <Route path="/terms-of-use" element={<TermsOfUsePage />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
                <Footer />
                <WhatsAppButton />
              </div>
            </BrowserRouter>
          </TermsOfUseProvider>
        </PrivacyPolicyProvider>
      </ApartmentContextProvider>
    </LanguageProvider>
  )
}

export default App
